/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Facility information for the receiver of the fax
 * @export
 * @interface FindAllSourceTags200ResponseDataInner
 */
export interface FindAllSourceTags200ResponseDataInner {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the FindAllSourceTags200ResponseDataInner interface.
 */
export function instanceOfFindAllSourceTags200ResponseDataInner(value: object): value is FindAllSourceTags200ResponseDataInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function FindAllSourceTags200ResponseDataInnerFromJSON(json: any): FindAllSourceTags200ResponseDataInner {
    return FindAllSourceTags200ResponseDataInnerFromJSONTyped(json, false);
}

export function FindAllSourceTags200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSourceTags200ResponseDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function FindAllSourceTags200ResponseDataInnerToJSON(json: any): FindAllSourceTags200ResponseDataInner {
    return FindAllSourceTags200ResponseDataInnerToJSONTyped(json, false);
}

export function FindAllSourceTags200ResponseDataInnerToJSONTyped(value?: FindAllSourceTags200ResponseDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

